module.exports = __webpack_public_path__ + "static/media/5.cefcd287.JPG";